
export const Toggle = ({ isOn, handleToggle, text }) => {

  return (
    <div style={{marginRight: "1rem"}} className="is-flex is-align-items-horizontal">
      <input
        checked={isOn}
        onChange={() => handleToggle(!isOn)}
        type="checkbox"
      /> <span style={{fontSize: ".9rem", marginLeft: ".2rem"}}>{text}</span>
    </div>
  );
};